module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg fr 2-8ce02b01396e8328cdca34acdfe62099.jpg";